import { ActionReducer } from '@ngrx/store/src/models';
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { UserPreferencesModel } from '../../../shared/models/user-preferences.model';
import { USER_PREFERENCES_ACTIONS, USER_PREFERENCES_API_ACTIONS } from '../actions/user-preferences.actions';
import { cloneDeep } from 'lodash';
import { MemoizedSelector } from '@ngrx/store/src/selector';

export const USER_PREFERENCES_STATE_KEY = 'user-preferences';

export interface IUserPreferencesState {
  loading: boolean;
  saving: boolean;
  getError: boolean;
  saveError: boolean;
  preferences: UserPreferencesModel;
}

export const initialState: IUserPreferencesState = {
  loading: true,
  saving: false,
  getError: false,
  saveError: false,
  preferences: new UserPreferencesModel(),
};

const reducer: ActionReducer<IUserPreferencesState> = createReducer<IUserPreferencesState>(
  initialState,
  on(USER_PREFERENCES_API_ACTIONS.get, (state) => ({ ...state, loading: true, getError: false })),
  on(USER_PREFERENCES_API_ACTIONS.getSuccess, (state, { data }) => ({
    ...state,
    loading: false,
    preferences: Object.assign({}, state.preferences, data),
  })),
  on(USER_PREFERENCES_API_ACTIONS.getError, (state) => ({ ...state, loading: false, getError: true })),

  on(USER_PREFERENCES_API_ACTIONS.upload, (state) => ({ ...state, saving: true, saveError: false })),
  on(USER_PREFERENCES_API_ACTIONS.uploadSuccess, (state) => ({ ...state, saving: false })),
  on(USER_PREFERENCES_API_ACTIONS.uploadError, (state) => ({ ...state, saving: false, saveError: true })),

  on(USER_PREFERENCES_ACTIONS.update, (state, { data }) => ({
    ...state,
    preferences: new UserPreferencesModel(Object.assign({}, state.preferences, cloneDeep(data))),
  })),
);

export const USER_PREFERENCES_REDUCER = createFeature({
  name: USER_PREFERENCES_STATE_KEY,
  reducer,
  extraSelectors: ({ selectPreferences }) => ({
    selectPreferenceByKey: <K extends keyof UserPreferencesModel, T = UserPreferencesModel[K] | undefined>(
      key: K,
    ): MemoizedSelector<object, T, (s1: UserPreferencesModel) => T> =>
      createSelector(selectPreferences, (selectPreferences) => selectPreferences[key] as T),
    favouritePagesUrl: createSelector(selectPreferences, ({ favouritePagesUrl }) => favouritePagesUrl),
    isNavigationPinned: createSelector(selectPreferences, ({ isNavigationPinned }) => isNavigationPinned),
    conversationGridViews: createSelector(selectPreferences, ({ conversationGridViews }) => conversationGridViews),
  }),
});
